<template>
  <div class="home">
    <h3>Dashboard</h3>
    <div class="empty">
      <div class="empty-icon">
        <i class="icon icon-4x icon-check"></i>
      </div>
      <p class="empty-title h5">Welcome, {{currentUser.displayName}}</p>
      <p class="empty-subtitle">You've successfully signed up</p>
      <div class="empty-action">
        <router-link class="btn btn-primary" to="/orders">View my orders</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "home",
  components: {},
  computed: {
    ...mapState(["currentUser"]),
    ...mapGetters(["isAuthenticated"])
  }
};
</script>
